/**
 * Whether `thread` belongs in the given rail scope.
 *
 * Mirrors `ThreadRepo.list`'s WHERE clause exactly:
 *   - closed is never in any rail scope;
 *   - a tech selection replaces the tab's ownership rule rather than adding
 *     to it (stacked, they were unsatisfiable);
 *   - `queue` is UNCLAIMED work, so claiming something removes it from
 *     everybody else's queue — which is the whole point;
 *   - `all` is every open thread, claimed or not.
 */
export function matchesScope(thread, scope) {
    // FAILS OPEN ON A FIELD IT CANNOT SEE. Callers use this to DROP threads, and
    // the harm being fixed is work disappearing — so a payload that does not
    // carry `ownerId` (a partial update, a future event shape) must not be read
    // as "not unclaimed" and quietly hidden. Showing one thread too many is a
    // nuisance; hiding one is the bug.
    //
    // A row from the database always has the column, so this never loosens the
    // server's own answer — see the agreement test in services/ops.
    if (thread.ownerId === undefined)
        return true;
    if (thread.state === 'closed')
        return false;
    if (scope.techId)
        return thread.ownerId === scope.techId;
    if (scope.filter === 'mine')
        return scope.selfId !== null && scope.selfId !== undefined && thread.ownerId === scope.selfId;
    if (scope.filter === 'queue')
        return thread.ownerId === null;
    return true;
}
